// extracted by mini-css-extract-plugin
export default {"input":"mgd07","description":"d8iqF","status-error":"rcat3","note":"sSRCi","btn-wrap":"frboC"};